import {
  EnumInpatientModule,
  GenericTheme,
  JsonHospitalConfig,
} from '@quality24/inpatient-typings';

export enum LoginState {
  NONE = 'none',
  AUTHENTICATED = 'authenticated',
}

/**
 * User role enum
 */
export enum AuthUserRole {
  ADMIN = 'ADMIN',
  ORG_ADMIN = 'ORG_ADMIN',
  HOSPITAL_ADMIN = 'HOSPITAL_ADMIN',
  SUPERVISOR = 'SUPERVISOR',
  OMBUDSMAN = 'OMBUDSMAN',
  MONITOR = 'MONITOR',
  FLOOR_MONITOR = 'FLOOR_MONITOR',
  GUEST = 'guest',
}

export interface AuthUser {
  id: string;
  role: AuthUserRole;
  organizationId: string;
  hospitalId: string;
  employeeId?: string;
  email?: string;
  modules?: Array<EnumInpatientModule>;
  hospitalConfig?: JsonHospitalConfig<GenericTheme>;
  departmentId?: string | null;
  departmentName?: string | null;
}

export interface AppUserData {
  /** Cognito auth data */
  'cognito:groups': string[];
  'cognito:roles': string[];
  'cognito:username': string;

  iss: string;
  email: string;
  sub: string;
  aud: string;
  event_id: string;
  token_use: string;
  origin_jti: string;
  auth_time: number;
  exp: number;
  iat: number;
  jti: string;

  /** Cognito custom data */
  'custom:hospital_id': string;
  'custom:organization_id': string;
  'custom:role': AuthUserRole;
  'custom:employeeId'?: string;
  'custom:user_id'?: string;

  /** Additional user data */
  hospitalName?: string;
  hospitalConfig?: JsonHospitalConfig;
  hospitalLgpdConsentHtml?: string | null;
  organizationName?: string;
  modules?: string[];
  isUserProvisioned?: boolean;
}

export interface AppAuthResponsePayload {
  userData: AppUserData;
}
